import { SET_PAGE_VISIBILITY } from '../actions/pageVisibilityActions';

const initialState = {
    visible: true
};

export function pageVisibility(state = initialState, action)
{
    switch (action.type)
    {
        case SET_PAGE_VISIBILITY:
        {
            return {
                ...state,
                visible: action.payload,
            };
        }
    }

    return state;
}

